// ========== Tire Specs JS ==========
(function () {
    if (!window.sectionId) {
        console.warn('acs tire specs: sectionId bulunamadi');
        return;
    }
    const sectionId = window.sectionId;

    const root = document.getElementById('MainProduct-' + sectionId);
    const fallbackValue = '-';

    if (!root) {
        return;
    }

    if (root.dataset.acsTireSpecsBound === 'true') {
        return;
    }

    root.dataset.acsTireSpecsBound = 'true';

    const badgeColorMaps = {
        fuel: {
            A: 'tw-bg-green-600',
            B: 'tw-bg-green-400',
            C: 'tw-bg-amber-300',
            D: 'tw-bg-amber-500',
            E: 'tw-bg-red-500',
            F: 'tw-bg-red-700'
        },
        wet: {
            A: 'tw-bg-sky-700',
            B: 'tw-bg-sky-600',
            C: 'tw-bg-sky-500',
            D: 'tw-bg-sky-400',
            E: 'tw-bg-sky-300'
        },
        noise: {
            A: 'tw-bg-slate-700',
            B: 'tw-bg-slate-600',
            C: 'tw-bg-slate-500'
        }
    };

    function normalizeNoiseClass(value) {
        if (value === null || value === undefined || value === '') return '';
        const normalized = String(value).trim().toUpperCase();
        if (normalized === '1') return 'A';
        if (normalized === '2') return 'B';
        if (normalized === '3') return 'C';
        return normalized;
    }

    function normalizeBoolean(value) {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number') return value === 1;
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y';
        }
        return false;
    }

    function textFromSpec(field, specs) {
        if (!specs) return fallbackValue;

        if (field === 'tire_noise_class') {
            const normalizedNoise = normalizeNoiseClass(specs[field]);
            return normalizedNoise || fallbackValue;
        }

        if (field === 'tire_snow_condition' || field === 'tire_ice_grip') {
            const value = specs[field];
            if (value === null || value === undefined || value === '') return fallbackValue;
            return normalizeBoolean(value) ? 'Ja' : 'Nein';
        }

        if (field === 'tire_vehicle_type') {
            //eger SUV ve PWK ise 'SUV & PKW' yaz, degilse tire_vehicle degeri yazacak
            const value = specs['tire_vehicle'];
            if (value === null || value === undefined || value === '') return fallbackValue;
            const normalized = String(value).trim().toUpperCase();
            if (normalized === 'SUV' || normalized === 'PKW') {
                return 'SUV & PKW';
            }
            return String(value);
        }
        if (field === 'tire_construction') {
            const value = specs['tire_size'];
            //örnek veri; 205/55 R16 91H
            //bu veriden R veya ZR harfini çekmeye çalışacağız
            if (value === null || value === undefined || value === '') return fallbackValue;
            const match = String(value).match(/\/\s*\d+\s*([A-Z]+)\d*\s/);
            if (match && match[1]) {
                return match[1];
            }
            return fallbackValue;
        }

        if (field === 'tire_load_version') {
            const value = specs['tire_size'];
            //örnek veri; 235/60 R18 107 V XL veya 215/55 ZR17 98W XL DOT2019
            //eger LX yaziyorsa load version XL, yoksa SL olacak sekilde cekmeye çalışacağız
            if (value === null || value === undefined || value === '') return fallbackValue;
            const normalized = String(value).toUpperCase();
            if (normalized.includes('XL')) return 'XL';
            if (normalized.includes('LX')) return 'XL';
            return 'SL';
        }



        const value = specs[field];
        if (value === null || value === undefined || value === '') return fallbackValue;
        return String(value);
    }

    let hasRenderedOnce = false;
    function triggerSpecFlash(el) {
        if (!hasRenderedOnce || !el) return;

        el.classList.remove('spec-change-flash');
        void el.offsetWidth;
        el.classList.add('spec-change-flash');

        window.setTimeout(function () {
            el.classList.remove('spec-change-flash');
        }, 700);
    }

    function updateTextFields(specs) {
        root.querySelectorAll('[data-spec-field]').forEach(function (el) {
            const field = el.getAttribute('data-spec-field');
            const suffix = el.getAttribute('data-spec-suffix') || '';
            const text = textFromSpec(field, specs);
            const hasValue = text !== fallbackValue;
            const nextText = hasValue ? text + suffix : fallbackValue;

            if (el.textContent !== nextText) {
                el.textContent = nextText;
                triggerSpecFlash(el);
            }
        });
    }

    function updateEprelBadges(specs) {
        root.querySelectorAll('[data-spec-badge]').forEach(function (el) {
            const field = el.getAttribute('data-spec-badge');
            const colorType = el.getAttribute('data-spec-color-type');
            const colorMap = badgeColorMaps[colorType] || {};

            const rawValue = specs ? specs[field] : '';
            const value = field === 'tire_noise_class'
                ? normalizeNoiseClass(rawValue)
                : (rawValue === null || rawValue === undefined ? '' : String(rawValue).trim().toUpperCase());

            const prevText = el.textContent;
            const prevClass = Array.from(el.classList).join(' ');

            Object.values(colorMap).forEach(function (className) {
                el.classList.remove(className);
            });

            if (!value) {
                el.textContent = fallbackValue;
                el.classList.add('tw-opacity-20');

                const nextClass = Array.from(el.classList).join(' ');
                if (prevText !== el.textContent || prevClass !== nextClass) {
                    triggerSpecFlash(el);
                }
                return;
            }

            el.textContent = value;
            el.classList.remove('tw-opacity-20');

            if (colorMap[value]) {
                el.classList.add(colorMap[value]);
            }

            const nextClass = Array.from(el.classList).join(' ');
            if (prevText !== el.textContent || prevClass !== nextClass) {
                triggerSpecFlash(el);
            }
        });
    }

    function updateBooleanIcons(specs) {
        root.querySelectorAll('[data-spec-boolean]').forEach(function (el) {
            const field = el.getAttribute('data-spec-boolean');
            const falseClass = el.getAttribute('data-spec-false-class') || 'tw-opacity-10';
            const isTrue = normalizeBoolean(specs ? specs[field] : false);
            el.classList.toggle(falseClass, !isTrue);
        });
    }

    function updateVisibilityAndFallbacks(specs) {
        root.querySelectorAll('[data-spec-group]').forEach(function (el) {
            const requiredField = el.getAttribute('data-spec-required-field');
            if (!requiredField) return;
            const value = specs ? specs[requiredField] : null;
            const shouldHide = value === null || value === undefined || value === '';
            el.classList.toggle('tw-hidden', shouldHide);
        });
    }

    function updateEprelResources(specs) {
        const imageEl = root.querySelector('#tire-eprel-label-image');
        const eprelLinkEl = root.querySelector('#tire-eprel-label-link');
        const pdfLinkEl = root.querySelector('#tire-eprel-label-pdf-link');

        const rawEprel = specs && specs.tire_eprel !== null && specs.tire_eprel !== undefined ? String(specs.tire_eprel).trim() : '';

        const hasEprel = rawEprel !== '';
        const labelUrl = hasEprel ? 'https://eprel.ec.europa.eu/labels/tyres/Label_' + rawEprel + '.svg' : '';
        const detailUrl = hasEprel ? 'https://eprel.ec.europa.eu/screen/product/tyres/' + rawEprel : '#';
        const pdfUrl = hasEprel ? 'https://eprel.ec.europa.eu/fiches/tyres/Fiche_' + rawEprel + '_DE.pdf' : '#';

        if (eprelLinkEl) {
            eprelLinkEl.setAttribute('href', detailUrl);
        }
        if (pdfLinkEl) {
            pdfLinkEl.setAttribute('href', pdfUrl);
        }
        if (imageEl) {
            const fallbackSrc = imageEl.getAttribute('data-fallback-src') || '';
            imageEl.onerror = function () {
                if (fallbackSrc) imageEl.src = fallbackSrc;
            };

            if (hasEprel) {
                imageEl.src = labelUrl;
                imageEl.classList.remove('tw-opacity-30');
            } else {
                imageEl.src = fallbackSrc || '';
                imageEl.classList.add('tw-opacity-30');
            }
        }
    }

    const specRenderers = [
        updateTextFields,
        updateEprelBadges,
        updateBooleanIcons,
        updateVisibilityAndFallbacks,
        updateEprelResources
    ];

    function renderAllSpecs(variantId) {
        const specs = window.tireVariantSpecs[variantId];

        console.log('variantId : ', variantId, 'specs: ', specs);

        specRenderers.forEach(function (renderer) {
            renderer(specs || null);
        });

        hasRenderedOnce = true;

        document.dispatchEvent(
            new CustomEvent('acs:tire-specs-updated', {
                detail: {
                    sectionId: sectionId,
                    variantId: variantId,
                    specs: specs || null
                }
            })
        );
    }

    function bindVariantInput() {
        const variantInput = root.querySelector('#acs-product-variant-id');
        if (!variantInput) {
            console.warn('acs tire specs: #acs-product-variant-id bulunamadi');
            return;
        }

        variantInput.addEventListener('change', function () {
            renderAllSpecs(this.value);
        });

        renderAllSpecs(variantInput.value);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindVariantInput, { once: true });
    } else {
        bindVariantInput();
    }
})();

// ========== Tab & Accordion JS ==========
(function () {
    var tabContainer = document.getElementById('product-tabs');
    if (!tabContainer) return;

    /* --- Desktop Tabs --- */
    var tabBtnsContainer = document.getElementById('product-tabs-buttons-desktop');
    var tabBtns = tabBtnsContainer ? tabBtnsContainer.querySelectorAll('.product-tab-btn') : [];
    var tabPanels = tabContainer.querySelectorAll('.product-tab-panel');

    if (tabBtns.length > 0) {
        /*tabBtns[0].classList.add('tw-border-red-600', 'tw-text-red-600');*/
        tabBtns[0].setAttribute('aria-selected', 'true');
    }

    tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var targetId = this.getAttribute('data-tab-target');

            tabBtns.forEach(function (b) {
                /*b.classList.remove('tw-border-red-600', 'tw-text-red-600');
              b.classList.add('tw-border-transparent');*/
                b.setAttribute('aria-selected', 'false');
            });

            /*', 'tw-text-red-600');
          this.classList.remove('tw-border-transparent');*/
            this.setAttribute('aria-selected', 'true');

            tabPanels.forEach(function (panel) {
                panel.classList.add('tw-hidden');
            });

            var target = document.getElementById(targetId);
            if (target) {
                target.classList.remove('tw-hidden');
            }
        });
    });

    /* --- Mobile Accordion --- */
    var accBtns = tabContainer.querySelectorAll('.product-accordion-btn');

    accBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var targetId = this.getAttribute('data-accordion-target');
            var panel = document.getElementById(targetId);
            if (!panel) return;

            var isOpen = this.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
                panel.style.maxHeight = '0';
                this.setAttribute('aria-expanded', 'false');
                this.querySelector('.product-accordion-icon').style.transform = 'rotate(0deg)';
            } else {
                panel.style.maxHeight = panel.scrollHeight + 'px';
                this.setAttribute('aria-expanded', 'true');
                this.querySelector('.product-accordion-icon').style.transform = 'rotate(180deg)';
            }
        });
    });
})();

// ========== Product Media Toggle (Image / Video) ==========
(function () {
    if (!window.sectionId) {
        return;
    }

    var root = document.getElementById('MainProduct-' + window.sectionId);
    if (!root) {
        return;
    }

    if (root.dataset.acsProductMediaBound === 'true') {
        return;
    }

    var imageWrap = root.querySelector('[data-product-media="image"]');
    var videoWrap = root.querySelector('[data-product-media="video"]');
    var videoEl = root.querySelector('[data-product-video]');
    var toggleButtons = root.querySelectorAll('[data-media-toggle]');

    if (!imageWrap || !videoWrap || toggleButtons.length === 0) {
        return;
    }

    root.dataset.acsProductMediaBound = 'true';

    function setMedia(type) {
        var showVideo = type === 'video';

        imageWrap.classList.toggle('tw-hidden', showVideo);
        videoWrap.classList.toggle('tw-hidden', !showVideo);

        toggleButtons.forEach(function (button) {
            var isActive = button.getAttribute('data-media-toggle') === type;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (!showVideo && videoEl) {
            videoEl.pause();
            videoEl.currentTime = 0;
        }
    }

    toggleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            setMedia(button.getAttribute('data-media-toggle'));
        });
    });

    // Always start with the default product image visible.
    setMedia('image');

    // When variant/spec changes, keep UX predictable by returning to image.
    document.addEventListener('acs:tire-specs-updated', function (event) {
        if (!event.detail || event.detail.sectionId !== window.sectionId) {
            return;
        }

        setMedia('image');
    });
})();